import { useLayoutEffect, useState } from "react";
import { NextPage } from "next";

import CookiePolicyPageContainer from "@/containers/CookiePolicyPage";

import { getURLParams } from "@/utils";
import MainTemplate from "@/components/Templates/MainTemplate";

interface CookiePolicyPage {}

const CookiePolicyPage: NextPage<CookiePolicyPage> = () => {
  const [isDesktopWebView, setIsDesktopWebView] = useState(false);

  useLayoutEffect(() => {
    const params = getURLParams();
    const source = params?.get("source") || "";

    if (source?.toLowerCase() !== "app") {
      setIsDesktopWebView(true);
    }
  }, []);

  return (
    <>
      {isDesktopWebView && (
        <MainTemplate>
          <main id="cookie-policy-page">
            <CookiePolicyPageContainer />
          </main>
        </MainTemplate>
      )}

      {!isDesktopWebView && (
        <main id="cookie-policy-page">
          <CookiePolicyPageContainer />
        </main>
      )}
    </>
  );
};

export default CookiePolicyPage;
